import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Phone, MessageCircle, MapPin } from 'lucide-react';
import { Button } from './ui/button';
import Header from './Header';
import Footer from './Footer';
import FloatingWhatsApp from './FloatingWhatsApp';

const ElettricististaRomaEUR = () => {
  const handleCall = () => {
    window.location.href = 'tel:3287686356';
  };

  const handleWhatsApp = () => {
    window.open('https://wa.me/393287686356?text=Ciao,%20ho%20bisogno%20di%20un%20elettricista%20urgente%20zona%20EUR%20Roma.', '_blank');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Elettricista Roma EUR H24 | Pronto Intervento Guasti Elettrici</title>
        <meta name="description" content="Elettricista Roma EUR H24. Guasti elettrici, salvavita, quadri, prese. Arriviamo in 30-60 minuti anche in zone a traffico limitato. Tel: 328 768 6356" />
        <link rel="canonical" href={`${window.location.origin}/elettricista-roma-eur`} />
      </Helmet>
      
      <div className="min-h-screen">
        <Header />
        
        <section className="bg-gradient-to-br from-blue-50 to-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <div className="flex items-center justify-center gap-2 mb-6">
                <MapPin className="h-8 w-8 text-blue-700" />
                <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
                  Elettricista Roma EUR
                </h1>
              </div>
              
              <p className="text-xl text-gray-700 text-center mb-8">
                Pronto intervento elettricista H24 zona EUR, Laurentina, Marconi, Ostiense. Arriviamo in 30-60 minuti anche in zone a traffico limitato.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
                <Button onClick={handleWhatsApp} size="lg" className="bg-orange-500 hover:bg-orange-600 text-white text-xl px-10 py-7">
                  <MessageCircle className="mr-3 h-7 w-7" />
                  WhatsApp Urgente
                </Button>
                <Button onClick={handleCall} size="lg" className="bg-blue-700 hover:bg-blue-800 text-white text-xl px-10 py-7">
                  <Phone className="mr-3 h-7 w-7" />
                  328 768 6356
                </Button>
              </div>

              <div className="bg-white p-8 rounded-lg shadow-lg">
                <h2 className="text-2xl font-bold text-gray-900 mb-4">
                  Elettricista Certificato Zona EUR Roma
                </h2>
                <p className="text-gray-700 text-lg mb-4">
                  SOS Casa Roma offre servizio elettricista certificato DM 37/08 nella zona EUR e quartieri limitrofi. I nostri tecnici elettricisti operano H24, 7 giorni su 7 inclusi festivi, garantendo interventi rapidi per ogni emergenza elettrica.
                </p>
                <p className="text-gray-700 text-lg mb-4">
                  <strong>Interventi elettrici EUR:</strong> Salvavita che scatta, blackout parziale, prese che non funzionano, cortocircuiti, quadri elettrici in blocco, interruttori guasti, luci che saltano, impianti elettrici difettosi.
                </p>
                <p className="text-gray-700 text-lg mb-4">
                  <strong>Zone operative:</strong> EUR Laurentina, EUR Torrino, Marconi, Ostiense, Garbatella, San Paolo, Magliana, Portuense.
                </p>
                <p className="text-gray-700 text-lg">
                  <strong>Certificazione DM 37/08:</strong> Tutti i nostri interventi sono certificati a norma di legge con rilascio regolare dichiarazione di conformità.
                </p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
        <FloatingWhatsApp />
      </div>
    </>
  );
};

export default ElettricististaRomaEUR;
